import { Component } from '@angular/core';

@Component({
  selector: 'atm-divider',
  templateUrl: './atm-divider.component.html',
  styleUrls: ['./atm-divider.component.scss'],
})
export class AtmDividerComponent {}
